import React, { useState } from 'react';
import { UserList } from '../components/UserList';
import { UserForm } from '../components/UserForm';

export const Users: React.FC = () => {
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  return (
    <div className="space-y-6">
      <UserForm
        user={selectedUser}
        onSave={() => {
          setSelectedUser(null);
          setRefreshTrigger(prev => prev + 1);
        }}
        onCancel={() => setSelectedUser(null)}
        onNarrative={(message, type) => console.log(message, type)}
      />
      <UserList
        onEdit={(user) => setSelectedUser(user)}
        selectedUser={selectedUser}
        refreshTrigger={refreshTrigger}
        onNarrative={(message, type) => console.log(message, type)}
      />
    </div>
  );
};